import classNames from 'classnames'
import styles from './TextLink.module.css'
import { type ForwardedRef, forwardRef } from 'react'
import { TextLinkProps } from './types'
// eslint-disable-next-line import/exports-last
export function headlessLinkProps({
  kind = 'default',
  className,
  largerClickArea,
  size = 'default',
  ...props
}: Omit<TextLinkProps, 'href'>) {
  return {
    ...props,
    className: classNames(styles.link, styles[`${kind}`], className, {
      [styles.largerClickArea as string]: largerClickArea,
      [styles.small as string]: size === 'small',
    }),
  }
}

const TextLink = forwardRef(function TextLink({ href, ...props }: TextLinkProps, ref: ForwardedRef<HTMLAnchorElement>) {
  const { children, ...props_ } = headlessLinkProps(props)
  return (
    <a ref={ref} href={href} {...props_}>
      {children}
    </a>
  )
})

export default TextLink
